import { unreachableFallback } from './unreachableFallback';
export const canRejectApproval = ({
  approvalType
}) => {
  switch (approvalType) {
    case 'DEAL':
    case 'QUOTE':
    case 'CONNECTED_APP':
      return true;
    case 'MARKETING_EMAIL':
    case 'LANDING_PAGE':
    case 'SITE_PAGE':
    case 'BLOG_POST':
    case 'KNOWLEDGE_ARTICLE':
    case 'SOCIAL_BROADCAST':
      return false;
    default:
      return unreachableFallback(approvalType, false);
  }
};